import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";
import { cn } from "@/lib/utils";

export function leadboxSheetSide(): "bottom" | "right" {
  return isNativeCapacitorApp() ? "bottom" : "right";
}

export function leadboxSheetContentClass(extra?: string): string {
  return cn(
    isNativeCapacitorApp()
      ? "native-full-sheet native-leadbox-sheet w-full max-w-none max-h-[92dvh] overflow-y-auto overflow-x-hidden"
      : "w-full sm:max-w-4xl overflow-y-auto",
    extra,
  );
}
